import uuid from "../../../utils/uuid";
const TransZoneEditor = ({ loc, onChanged, data: { transZone } }) => {
    const transZoneID = "edit.TransZone";
    const vals = [
        ["Undefined", "-"],
        ["V1", "V1"],
        ["V1-V2", "V1-V2"],
        ["V2", "V2"],
        ["V2-V3", "V2-V3"],
        ["V3", "V3"],
        ["V3-V4", "V3-V4"],
        ["V4", "V4"],
        ["V4-V5", "V4-V5"],
        ["V5", "V5"],
        ["V5-V6", "V5-V6"],
        ["V6", "V6"]
    ];

    const options = vals.map(it => (
        <option value={it[0]} key={uuid()}>
            {it[1]}
        </option>
    ));

    return (
        <div className="ctrl-input-group-ST">
            <label className="Zone-label" htmlFor={transZoneID}>
                {loc("report.params.transZone")}
            </label>

            <select
                className="ctrl-input"
                id={transZoneID}
                value={transZone}
                onChange={e => {
                    onChanged(transZoneID, { transZone: e.target.value });
                }}>
                {options}
            </select>
        </div>
    );
};

export default TransZoneEditor;
